/* eslint-disable indent */
// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './adjustment.scss';

const ViewAdjustment = props => {
    const { data } = props;

    return (
        <form className="adjustments-view">
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Merchant Name</p>
                    <p className="user-text">{data.merchantName}</p>
                </div>
                <div className="form-field">
                    <p className="label">Merchant ID</p>
                    <p className="user-text">{data.merchantId}</p>
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Adjustment Type</p>
                    <p className="user-text">{data.adjustmentType}</p>
                </div>
                <div className="form-field">
                    <p className="label">Adjustment Category</p>
                    <p className="user-text">{data.adjustmentcategory}</p>
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Chargeback and Transaction ID</p>
                    <p className="user-text">{data.adjustmentId}</p>
                </div>
            </div>

            <div className="form-section">
                <div className="form-field">
                    <p className="label">Amount</p>
                    <p className="user-text">{data.adjustmentAmount}</p>
                </div>
            </div>
            <div className="form-section message-section">
                <div className="form-field">
                    <p className="label">Remarks</p>
                    <p className="message-text">{data.remark}</p>
                </div>
            </div>
        </form>
    );
};

ViewAdjustment.propTypes = {
    data: PropTypes.object.isRequired,
};

export default ViewAdjustment;
